module.exports = __webpack_public_path__ + "img/program-3-2.1cc24e65.png";